import { isLoggedIn, useGlobalState } from "../GlobalStates";

export function useIsAuthenticated() {
  const [user] = useGlobalState("user");
  const [userLoading] = useGlobalState("userLoading");

  return {
    isAuthenticated: !userLoading && user && isLoggedIn(user),
    isLoading: userLoading,
    user,
  };
}

export function parseUserLanguages(languages) {
  if (!languages) return [];

  const languagePart = languages.slice(1, -1);

  if (languagePart.length === 0) return [];

  return languagePart.split(",");
}
